module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "beginLoading"
    }
  }, [_c('div', {
    staticClass: "loading"
  }, [_vm._m(0), _vm._v(" "), _c('canvas', {
    ref: "canvasLoading",
    attrs: {
      "id": "canvas",
      "width": "200",
      "height": "200"
    }
  })]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "particles"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logoImg"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/cnodejs_light.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-ce8da3c0"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/beginLoading/beginLoading.vue
// module id = 338
// module chunks = 4